// Home.jsx
import React from "react";
import { Box, Grid, Typography, Paper, Avatar } from "@mui/material";

export const Home = () => {
  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: { xs: 2, md: 4 }, pb: 0 }}>
      <Typography
        variant="h1"
        align="center"
        color="text.primary"
        sx={{ mb: { xs: 2, md: 4 }, fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }, lineHeight: { xs: 1.2, md: 1.1 } }}
      >
        Hello and Welcome to my World
      </Typography>
      <Box sx={{ mx: 'auto', width: { xs: '90%', md: '60%' }, borderBottom: '1px solid', borderColor: 'divider', mb: { xs: 1, md: 2 } }} />
      <Grid container spacing={{ xs: 2, md: 4 }} alignItems="stretch">
        <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' }, height: { md: 520 } }}>
          <Paper elevation={6} sx={{ borderRadius: 2, overflow: 'hidden', width: '100%', maxWidth: { xs: '100%', md: 460 }, height: '100%' }}>
            <Avatar
              variant="square"
              src="/assets/sarah581.jpg"
              alt="Sara Bassam Hafez"
              sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={8} sx={{ display: 'flex' }}>
          <Box sx={{ height: { xs: 'auto', md: 500 }, display: 'flex', alignItems: { xs: 'flex-start', md: 'center' }, width: '100%' }}>
            <Box sx={{ bgcolor: 'custom.beige', p: { xs: 2, md: 3 }, borderRadius: 2, width: '100%', height: { xs: 'auto', md: '100%' }, display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" color="text.primary" sx={{ whiteSpace: 'pre-line', fontSize: { xs: 17, md: 20, lg: 21 }, lineHeight: { xs: 1.6, md: 1.7 } }}>
                {`I would like to introduce you to myself; I’m Sara Bassam Hafez, a mother of two, and a passionate self-explorer whose vision in life is “you can create the extraordinary life you dream of no matter what”.

            From a very young age, I have always been interested in how our thoughts and behaviors shape our destinies, and through my journey, I was inspired by so many people that have crossed my path. From there I found a deep calling within myself to expand this. So here I am trying to put together all that has inspired me to create my extraordinary journey, hoping that they will inspire you to create your extraordinary journey as well.`}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={{ xs: 2, md: 4 }} sx={{ mt: { xs: 3, md: 6 }, mb: 0 }} justifyContent="flex-end">
        <Grid item xs={12} md={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="h5" color="text.primary" fontWeight={700}>
              THANKS IN ADVANCE FOR PUTTING YOUR TRUST IN ME…
            </Typography>
            <Typography variant="h5" color="text.primary" fontWeight={700}>
              {`with lots of love,
            Sara`}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
